import { CheckCompany, CheckEnrollmentProfile } from "winslow-core";
import { Alert, AlertDescription } from "../../../ds2/components/Alert";
import { Button } from "../../../ds2/components";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import { useNavigate } from "react-router-dom";
import config from "environment";

const isProd = config.environment === "production";

const KYB_STATUS_TO_TEXT = {
    "four_day_approved": "four day approval",
    "denied": "denied",
    "two_day_approved": "two day approval",
    "three_day_approved": "three day approval",
}

type AppCheckCompanyStatusProps = {
    checkCompany: CheckCompany;
    enrollmentProfile: CheckEnrollmentProfile;
    activeCheckEmployeesContractorsCount: number | null;
    handleLaunchCheckOnboarding: () => void;
    handleLaunchCheckImplementation: () => void;
}

export const AppCheckCompanyStatus = ({ 
    checkCompany,
    enrollmentProfile,
    activeCheckEmployeesContractorsCount,
    handleLaunchCheckOnboarding,
    handleLaunchCheckImplementation
}: AppCheckCompanyStatusProps) => {

    const navigate = useNavigate();

    // Use active check employees/contractors count from database instead of enrollmentProfile
    const checkEmployeeContractorCount = activeCheckEmployeesContractorsCount ?? 0;
 
    console.log("[AppCheckCompanyStatus] checkEmployeeContractorCount", checkEmployeeContractorCount);
    return (
        <>
            {/* Onboarding not completed */}
            {checkCompany && checkCompany.onboard?.status !== "completed" && 
                <Alert variant="destructive" className="app-pay-configuration-alert">
                    Enrollment is not complete or needs attention. Please resolve the issues to continue.
                    <Button
                        label="Resolve"
                        variant="secondary"
                        onClick={handleLaunchCheckOnboarding}
                    />
                    {!isProd &&
                        <>
                            <p/>
                            {JSON.stringify(checkCompany.onboard)}
                        </>
                    }
                </Alert>
            }
            {/* Need to kick off implementation */}
            {checkCompany && checkCompany.onboard?.status === "completed" && 
                checkCompany.implementation?.status === "needs_attention" && 
                checkCompany.implementation?.remaining_steps?.kyb?.status === "not_initiated" &&
                checkEmployeeContractorCount > 0 &&
                <Alert variant="destructive" className="app-pay-configuration-alert">
                    <AlertDescription>
                        Company is ready for implementation.
                    </AlertDescription>
                    <Button
                        label="Implement"
                        variant="secondary"
                        onClick={handleLaunchCheckImplementation}
                    />
                </Alert>
            }

            {/* can't start implementation if there are no employees or contractors */}
            {checkCompany && checkCompany.onboard?.status === "completed" && 
                checkCompany.implementation?.status === "needs_attention" && 
                checkCompany.implementation?.remaining_steps?.kyb?.status === "not_initiated" &&
                checkEmployeeContractorCount < 1 &&
                <Alert variant="destructive" className="app-pay-configuration-alert">
                    <AlertDescription>
                        Add employees or contractors to enable payroll enrollment.
                    </AlertDescription>
                    <Button
                        label="Add Employees"
                        variant="secondary"
                        onClick={()=>{navigate(`/app/employee-records`)}}
                    />
                </Alert>
            }

            {/* Implementation completed */}
            {checkCompany && checkCompany.onboard?.status === "completed" && 
                checkCompany.implementation?.status === "needs_attention" && 
                checkCompany.implementation?.remaining_steps?.kyb?.status !== "not_initiated" &&
                <Alert variant="success" className="app-pay-configuration-alert">
                    <AlertDescription>
                        Company payroll enrollment is being reviewed ({KYB_STATUS_TO_TEXT[checkCompany.implementation?.remaining_steps?.kyb?.status as keyof typeof KYB_STATUS_TO_TEXT]}).
                    </AlertDescription>
                </Alert>
            }

            {/* IN Review KYB */}
            {checkCompany && checkCompany.onboard?.status === "completed" && 
                checkCompany.implementation?.status === "in_review" &&
                <Alert variant="success" className="app-pay-configuration-alert">
                    <AlertDescription>
                        Company payroll enrollment is being reviewed.
                    </AlertDescription>
                </Alert>
            }
        </>
    )
}

